import React from 'react'
import { selectPath, changeColors } from '../../actions/index'
import FigureMenu from './figureMenu'
import { connect } from 'react-redux'

const mapStateToProps = ( state, props ) => ({
	paths: state.tiles[state.selectedTile].paths,
	selectedPath: state.selectedPath,
	colors: state.currentColors
	//colors: state.tiles[state.selectedTile].colorScheme[state.selectedSample]
});

const mapDispatchToProps = ( dispatch, props ) => ({
	onClick : ( id ) => { dispatch( selectPath( id ) );  }
});

const VisibleColorMenu = connect(mapStateToProps, mapDispatchToProps) (FigureMenu)

export default VisibleColorMenu;


// WEBPACK FOOTER //
// ./src/components/mosaic/visibleFigureMenu.jsx